<template>
  <div>
    <v-dialog
      @keydown.esc="isOpen=false"
      persistent
      v-model="isOpen"
      width="850px">
      <v-card>
        <v-card-title>
          Actualizar precios
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              Encontramos <b class="primary--text">{{ totalOrders }} órdenes de compra nuevas</b>
              que también tienen el producto <b class="primary--text">{{ product.name }}</b>.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
             ¿Deseas actualizar el precio de <b class="primary--text">{{ product.name }}</b>
             a <b class="primary--text">{{ product.amount | toFixNumber(2) | numberWithComma | prefix('$') }}</b>
             en estas órdenes de compra?
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="orders"
                :server-items-length="totalOrders"
                :items-per-page="totalOrders"
                class="elevation-1"
                :options="options"
                :footer-props="{
                  'items-per-page-options': [5, 10, 15, 20]
                }"
              >
                <template v-slot:item.status="{ item }">
                  <v-icon>{{ item.isRead ? 'mdi-check-circle' : 'mdi-inbox-arrow-down' }}</v-icon>
                  {{ item.isRead ? 'Por confirmar' : 'Nuevos pedidos' }}
                </template>
                <template v-slot:item.product="{ item }">
                  {{ item.product.amount | toFixNumber(2) | numberWithComma | prefix('$') }}
                </template>
                <template v-slot:item.updatedAt="{ item }">
                  {{ item.updatedAt | toDate }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded
            outlined
            small
            depressed
            @click="closeDialog">
            {{ $t('orders.buttons.noUpdate') }}
          </v-btn>
          <v-btn
            color="secondary"
            rounded
            dark
            small
            depressed
            @click="propagatePriceToOrders([], true)">
            {{ $t('orders.buttons.propagatePriceToOrders') }}
          </v-btn>
          <v-btn
            v-if="allowPropagateToCatalog"
            color="primary"
            rounded
            dark
            small
            depressed
            @click="propagatePriceToOrdersAndProduct">
            {{ $t('orders.buttons.propagatePriceToOrdersAndProduct') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  props: {
    allowPropagateToCatalog: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      product: {
        name: 'Cebolla Blanca'
      },
      order: '',
      orders: [],
      headers: [
        { text: 'Orden', value: 'uuid', sortable: false },
        { text: 'Estatus', value: 'status', sortable: false },
        { text: 'Restaurante', value: 'restaurant.name', sortable: false },
        { text: 'Precio actual en orden', value: 'product', sortable: false, align: 'right' },
        { text: 'Último cambio de estatus', value: 'updatedAt', sortable: false }
      ],
      options: {
        itemsPerPage: 15,
        page: 1
      }
    }
  },
  computed: {
    totalOrders () {
      return (this.orders || []).length
    },
    provider () {
      return this.$store.state.currentProvider.data
    }
  },
  methods: {
    async open (product, order, getByProduct) {
      if (product || order) {
        this.product = { ...product }
        this.order = order || ''
        await this.getOrders(getByProduct)
      }
    },
    closeDialog () {
      this.isOpen = false
      this.product = {
        name: null
      }
      this.orders = []
    },
    async getOrders (getByProduct) {
      this.overlay = true
      try {
        let orders = []

        if (getByProduct) {
          const params = {
            provider: this.provider._id,
            product: this.product.product,
            choice: this.product.choice._id === undefined ? this.product.choice : this.product.choice._id
          }
          orders = await this.$api.post(`/v1/catalog/find-variant-in-order`, params)
        } else {
          orders = await this.$api.post(`/v1/orders/${this.order}/find-product-in-order`, {
            product: this.product.product,
            choice: this.product.choice._id === undefined ? this.product.choice : this.product.choice._id
          })
        }
        const [newOrders, sentOrders] = orders.reduce((acc, curr) => {
          if (curr.status === 'created') acc[0].push(curr)
          if (curr.status === 'sent') acc[1].push(curr)
          return acc
        }, [[], []])
        await this.propagatePriceToNewOrders(newOrders)
        if (sentOrders.length === 0) {
          this.closeDialog()
        } else {
          this.orders = sentOrders.map(order => ({
            ...order,
            product: order.products.find(prod => prod.choice === this.product.choice ? this.product.choice._id : this.product.choice)
          }))
          this.isOpen = true
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
      }
      this.overlay = false
    },
    async propagatePriceToNewOrders (orders = []) {
      if (orders.length) {
        this.overlay = true
        try {
          for (const order of orders) {
            const payload = {
              orders: [order._id],
              product: this.product.product,
              choice: this.product.choice._id === undefined ? this.product.choice : this.product.choice._id,
              newPrice: this.product.amount,
              updateCatalog: false
            }
            await this.$api.put(`/v1/orders/${order._id}/propagate-amount-orders`, payload)
          }
          this.$emit('updated')
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
        }
        this.overlay = false
      }
    },
    async propagatePriceToOrders () {
      this.overlay = true
      try {
        for (const order of this.orders) {
          const payload = {
            orders: [order._id],
            product: this.product.product,
            choice: this.product.choice._id === undefined ? this.product.choice : this.product.choice._id,
            newPrice: this.product.amount,
            updateCatalog: false
          }
          await this.$api.put(`/v1/orders/${order._id}/propagate-amount-orders`, payload)
        }
        this.$toasted.show('Los precios en las ordernes de compra se actualizaron correctamente', { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
        this.$emit('updated')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
      }
      this.overlay = false
      this.closeDialog()
    },
    async propagatePriceToOrdersAndProduct () {
      this.overlay = true
      try {
        for (const order of this.orders) {
          const payload = {
            orders: [order._id],
            product: this.product.product,
            choice: this.product.choice._id === undefined ? this.product.choice : this.product.choice._id,
            newPrice: this.product.amount,
            updateCatalog: true
          }
          await this.$api.put(`/v1/orders/${order._id}/propagate-amount-orders`, payload)
        }
        this.$toasted.show('Los producto y ordenes de compra se actualizaron correctamente', { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
        this.$emit('updated')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
      }
      this.overlay = false
      this.closeDialog()
    }
  }
}
</script>
